import React, { useState } from 'react'
import { getFounder } from '../../api/contactus'
import { useQuery } from '@tanstack/react-query'
import Pagination from '../../components/Pagination'
import { FiLoader } from 'react-icons/fi'
import { Link } from 'react-router-dom'

const Founder = () => {
  const [page, setPage] = useState(1)

  const { isPending, isError, error, data } = useQuery({
    queryKey: ['founder', page],
    queryFn: () => getFounder(page),
    refetchOnWindowFocus: false,
  })

  const founders = data?.founders || []

  const totalPages = Math.ceil(data?.totalCount / 9)

  // 🔹 Mutation for Delete
  // const deleteMutation = useMutation({
  //   mutationFn: async (id) => {
  //     // call your delete founder API
  //     console.log('Delete founder:', id)
  //     toast.success('Founder deleted')
  //   },
  //   onSuccess: () => {
  //     queryClient.invalidateQueries(['founder'])
  //   },
  // })

  // 🔹 Loading
  if (isPending) {
    return (
      <div className="flex justify-center items-center h-80">
        <FiLoader className="w-8 h-8 animate-spin text-orange-500" />
        <span className="ml-3 text-gray-600 text-lg font-medium">
          Loading founders...
        </span>
      </div>
    )
  }

  // 🔹 Error
  if (isError) {
    return (
      <div className="text-center text-red-600 mt-20">
        <p className="text-lg font-semibold">Failed to load data 😞</p>
        <p className="text-gray-500">{error?.message}</p>
      </div>
    )
  }

  return (
    <div className="min-h-screen bg-gray-50 p-6">
      <h2 className="text-2xl font-aptos-semibold text-gray-800 text-center mb-6">
        Founders
      </h2>

      {/* Founder Grid */}
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        {founders.map((item) => (
          <div
            key={item.id}
            className="bg-white p-5 rounded-xl border shadow-sm"
          >
            <p className="text-gray-700 text-base mb-1">
              <strong>Name:</strong> {item.fullName}
            </p>

            <p className="text-gray-700 text-base mb-1">
              <strong>Email:</strong> {item.email}
            </p>

            <p className="text-gray-700 text-base mb-1">
              <strong>Mobile:</strong> {item.mobile}
            </p>

            <p className="text-gray-700 text-base mb-1">
              <strong>Company:</strong> {item.companyName || 'N/A'}
            </p>

            <p className="text-gray-700 text-base mb-1">
              <strong>Startup:</strong> {item.startup || 'N/A'}
            </p>

            <p className="text-gray-700 text-base mb-1">
              <strong>Amount:</strong>{' '}
              <span
                className={`px-2 py-1 rounded text-sm ${
                  item.amount === 'UNPAID'
                    ? 'bg-red-100 text-red-800'
                    : 'bg-green-100 text-green-800'
                }`}
              >
                {item.amount}
              </span>
            </p>

            {/* Action Buttons */}
            <div className="flex gap-3 mt-5 text-center">
              <Link
                to={`update/${item.id}`}
                className="flex-1 bg-blue-600 text-white py-2 rounded-lg hover:bg-blue-700 transition"
              >
                Edit
              </Link>

              <Link
                to={`list/company/${item.id}`}
                className="flex-1 bg-green-700 text-white py-2 rounded-lg hover:bg-green-600 transition"
              >
                List Startup
              </Link>
            </div>
          </div>
        ))}
      </div>

      {/* Pagination */}
      <div className="mt-8 flex justify-center">
        <Pagination page={page} setPage={setPage} totalPages={totalPages} />
      </div>
    </div>
  )
}

export default Founder
